export const eligible = ['uptime', 'networkInfo', 'boxFirmware', 'portStatuses', 'wifiInfo'];
export const objectCheck = [
  'uptime',
  'operstate',
  'networkInfo',
  'wifiInfo',
  'boxFirmware',
  'portStatuses',
];
export const sysInfoSortArr = [
  'networkInfo',
  // 'boxFirmware',
  'cpu',
  'diskIo',
  'diskUsage',
  'loadavg',
  'memory',
  'network',
  'operstate',
  // 'portStatuses',
  'uptime',
  // 'wifiInfo',
];
